import { Inbox, Star, Search, Activity } from "lucide-react";

const META = {
  booking: { icon: Inbox, cls: "bg-accent/10 text-accent", label: "New booking" },
  review: { icon: Star, cls: "bg-amber-100 text-amber-700", label: "New review" },
  search: { icon: Search, cls: "bg-emerald-100 text-emerald-700", label: "Search" },
};

const timeAgo = (iso) => {
  if (!iso) return "";
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
};

export const ActivityPanel = ({ items }) => (
  <div className="mt-6" data-testid="activity-panel">
    <div className="rounded-2xl border border-border bg-card p-6 sm:p-8">
      <div className="flex items-center gap-3 mb-4">
        <span className="grid place-items-center h-11 w-11 rounded-xl bg-accent/10 text-accent">
          <Activity className="h-6 w-6" />
        </span>
        <div>
          <h2 className="font-heading font-extrabold text-xl text-foreground">Recent activity</h2>
          <p className="text-muted-foreground text-sm">The latest bookings, reviews, and searches from your site.</p>
        </div>
      </div>

      {items.length === 0 ? (
        <div data-testid="activity-empty" className="py-12 text-center">
          <Activity className="h-10 w-10 text-muted-foreground mx-auto mb-3" />
          <p className="font-heading font-bold text-lg text-foreground">Nothing yet</p>
          <p className="mt-1 text-muted-foreground">New activity from your website will show up here.</p>
        </div>
      ) : (
        <ul className="space-y-2">
          {items.map((it, i) => {
            const meta = META[it.type] || META.search;
            const Icon = meta.icon;
            return (
              <li
                key={`${it.type}-${it.created_at}-${i}`}
                data-testid={`activity-row-${i}`}
                className="flex items-center gap-4 rounded-xl p-3 hover:bg-muted transition-colors"
              >
                <span className={`grid place-items-center h-10 w-10 rounded-xl shrink-0 ${meta.cls}`}>
                  <Icon className="h-5 w-5" />
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-foreground font-semibold truncate">
                    {meta.label}: <span className="font-normal">{it.title}</span>
                  </p>
                  <p className="text-muted-foreground text-sm truncate">{it.detail}</p>
                </div>
                <span className="text-muted-foreground text-xs shrink-0">{timeAgo(it.created_at)}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  </div>
);
